import {css} from "lit";
import {iconStyles} from "../styles/Icons.js";

export const dropdownItemStyles = [iconStyles, css`
	.dropdown-item {
		position: static;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		font-family: inherit;
		font-size: inherit;
		text-align: left;
		text-decoration: none;
		width: 100%;
		margin: 0;
		padding: 11px 13px;
		color: var(--pn-dropdown-item-text-color);
		border: none;
		background: var(--pn-dropdown-item-bg-color);

		/* TODO: may want to change later, added for integration signup */
		white-space: nowrap;
	}

	.dropdown-item:hover,
	.dropdown-item:focus, 
	.dropdown-item.--focus-within {
		padding: 11px 13px;
		border-top: none;
		border-bottom: none;
		background-color: var(--pn-dropdown-item-bg-color-hover);
		color: var(--pn-dropdown-item-text-color-hover);
		outline: none;
	}

	a {
		display: block;
		padding: 3px 20px;
		clear: both;
		text-decoration: none;
		font-weight: normal;
/* color: @dropdown-link-color; */
		white-space: nowrap; // prevent links from randomly breaking onto new lines
	}

	a:focus, a:hover {
		text-decoration: none;
		color: @dropdown-link-hover-color;
		border: none;
		background-color: @dropdown-item-bg-color-hover;
	}

	.show-divider-under:not(:last-child) {
		border-bottom: 1px solid var(--pn-dropdown-divider-color);
	}

	.dropdown-item:hover + ::slotted(pn-dropdown-submenu),
	.dropdown-item:focus + ::slotted(pn-dropdown-submenu),
	.dropdown-item.--focus-within + ::slotted(pn-dropdown-submenu),
	::slotted(pn-dropdown-submenu:hover) {
		display: block;
	}

	::slotted(*:not(pn-dropdown-submenu)) {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.dropdown-item-wrapper .dropdown-item::after {
		display: block;
		content: ' ';
		float: right;
		width: 0;
		height: 0;
		border-color: transparent;
		border-style: solid;
		border-width: 4px 0 4px 4px;
		border-left-color: var(--pn-dropdown-item-text-color);
		margin-bottom: 3px;
		margin-left: auto;
	}


	/* For the topics list */
	::slotted(i.icon-circle) {
		display: inline-block;
		margin-bottom: 2px;
		margin-right: 7px;
		font-size: var(--pn-font-size-small);
	}

	::slotted(.dropdown-text) {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}

	::slotted(.dropdown-text-topic) {
		max-width: 80%;
	}

	.link-add-topic {
		margin: 8px 0 2px;
		padding: 10px 11px;
		border: none;
		color: var(--pn-button-link-default-color);
		font-size: calc(var(--pn-font-size-base) - 1px);
		text-align: left;
		line-height: 1;
	}
	.link-add-topic:hover {
		padding: 10px 11px;
		background: transparent;
		color: var(--pn-button-link-default-color-hover);
		transition: all;
		transition-duration: .1s;
	}
	::slotted(.icon-add.add-topic) {
		display: inline-block;
		background-color: var(--pn-button-link-default-color);
		margin-right: 5px;
		vertical-align: baseline;
		font-size: calc(var(--pn-font-size-small) - 4px);
	}

	.dropdown-item:hover ::slotted(.icon-add.add-topic),
	.dropdown-item:focus ::slotted(.icon-add.add-topic), 
	.dropdown-item.--focus-within ::slotted(.icon-add.add-topic) {
		background-color: var(--pn-button-link-default-color-hover);
	}
`];
